@use "variables" as *;

.mainDiv {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-image: url(../../images/login_background.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.mainContent {
  max-width: 340px;
}

.logoImage {
  width: 150px;
  filter: drop-shadow(2px 2px 2px #222);
  align-self: center;
  margin-top: $spacing-g;
  margin-bottom: $spacing-xxl;
}

.title {
  color: white;
  text-align: center;
}

.subtitle {
  color: white;
  text-align: center;
  white-space: pre-wrap;
}
